//vendors
import React from 'react';
import { flexChildStyle } from './flexUtils';

type Props = {
  size?: string,
  height?: string,
  width?: string,
  className?: string,
  style?: Object
};

export const Gap = ({
  size,
  width,
  height,
  className,
  style
} : Props) => {
  let styles: any = size ? flexChildStyle(size) : {};
  width && (styles.width = width);
  height && (styles.height = height);

  style && (styles = { ...styles, ...style });

  return <div className={className} style={styles} />
};
